export default "__VITE_ASSET__BQHK5g1h__"